import { useState } from 'react';
import { api } from '../api.js';

export default function InviteModal({ students, onClose }) {
  const [email, setEmail]     = useState('');
  const [name, setName]       = useState('');
  const [studentId, setStudentId] = useState('');
  const [saving, setSaving]   = useState(false);
  const [success, setSuccess] = useState(false);
  const [warning, setWarning] = useState(null);
  const [error, setError]     = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true); setError(null);
    try {
      const res = await api.invite({ email, display_name: name || undefined, student_id: studentId ? Number(studentId) : undefined });
      setWarning(res?.warning ?? null);
      setSuccess(true);
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="card max-w-sm w-full space-y-4">
        <h2 className="font-bold text-gray-900">📧 Schüler einladen</h2>
        {success ? (
          <div className="space-y-3">
            <div className="rounded-lg bg-green-50 border border-green-200 p-3 text-sm text-green-800">
              ✅ <strong>{email}</strong> wurde eingeladen. Der Schüler kann sich jetzt mit
              seinem E-Mail-Einmalcode anmelden.
            </div>
            {warning && (
              <div className="rounded-lg bg-amber-50 border border-amber-200 p-3 text-sm text-amber-800">
                <strong>Achtung:</strong> {warning}
              </div>
            )}
            <button onClick={onClose} className="btn-primary w-full">Schließen</button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <div>
              <label className="label">E-Mail-Adresse *</label>
              <input type="email" className="input" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="schueler@example.com" required />
            </div>
            <div>
              <label className="label">Anzeigename (optional)</label>
              <input className="input" value={name} onChange={(e) => setName(e.target.value)}
                placeholder="z.B. Klaus M." />
            </div>
            <div>
              <label className="label">Schüler-Datensatz verknüpfen (optional)</label>
              <select className="input" value={studentId} onChange={(e) => setStudentId(e.target.value)}>
                <option value="">— kein Tracking-Datensatz —</option>
                {students.map((s) => (
                  <option key={s.id} value={s.id}>{s.kuerzel} (Stufe {s.stufe_ziel})</option>
                ))}
              </select>
            </div>
            {error && <p className="text-sm text-red-600">{error}</p>}
            <div className="flex gap-2 justify-end">
              <button type="button" onClick={onClose} className="btn-secondary">Abbrechen</button>
              <button type="submit" className="btn-primary" disabled={saving}>
                {saving ? 'Einladen…' : 'Einladen'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
